export default __webpack_public_path__ + "static/media/stage.977656e3.png";